import { useTranslation } from 'react-i18next';

import useDeleteSchedule from 'Domain/schedule/useDeleteSchedule';
import { useModal } from 'Store/modal';
import { useScheduleState } from '../state';

const useModalDeleteSchedule = () => {
  const { t } = useTranslation('schedule');
  const { onOpenModal, onResetModal } = useModal();
  const { filterState } = useScheduleState();

  const { mutate } = useDeleteSchedule({ onResetModal, filters: filterState });

  const onOpenModalDeleteSchedule = ({ id, onClose }) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('deleteScheduleTitle'),
      contentDescription: t('deleteScheduleDescription'),
      showPrimaryButton: true,
      primaryButtonText: t('deleteSubmitButton'),
      showSecondaryButton: true,
      secondaryButtonText: t('deleteCancelButton'),
      onClickPrimaryButton: () => {
        mutate(id);
        onResetModal();
        onClose?.();
      },
      onClickSecondaryButton: () => {
        onResetModal();
        onClose?.();
      },
      customOnCloseModal: () => {
        onClose?.();
      },
    });
  };

  return { onOpenModalDeleteSchedule };
};

export default useModalDeleteSchedule;
